import {addResolvedPropertyMapping, isSelector} from '../property-selectors';

/**
 * function to update resolvedSelectedPropertyMapping when the property value does not contain selector
 * but itself is selectable, it could become a provider property for other consumer components
 * @param {string} propertyValue
 * @param {string} providerPropName
 * @param {string} providerId
 */
export default function addResolvedSelectedPropertyMappingWithResolvedValue(
	propertyValue,
	providerPropName,
	providerId
) {
	if (isSelector(propertyValue)) return;

	addResolvedPropertyMapping({providerId, providerPropName}, propertyValue);
}
